import React from 'react';

export const NoResults = ({
  searchValue,
}: {
  searchValue: string;
}): JSX.Element => (
  <p>
    No search results for &#x2018;<strong>{searchValue}</strong>&#x2019;.
  </p>
);

export default NoResults;
